import { jsx as _jsx } from "react/jsx-runtime";
import { useLoader } from '@react-three/fiber';
import React, { useMemo, memo } from 'react';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js';
import SvgShape from './SvgShape';
const shapesCache = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getViewBox = (svgs) => {
    const str = svgs[0]?.xml.outerHTML;
    const tP = new DOMParser().parseFromString(str.toString(), 'image/svg+xml');
    const tS = document.importNode(tP.documentElement, true);
    const tV = tS.getAttribute('viewBox');
    return tV?.split?.(' ')?.map(x => +x) || null;
};
const SvgComponent = ({ svgUrl, scale, name, opacity, position = [0, 0, 0], color: c, renderOrder = 0, visible = true, raycast }) => {
    // console.log({svgUrl});
    const urls = useMemo(() => [`${svgUrl}?=webgl`], [svgUrl]);
    const svgs = useLoader(SVGLoader, urls);
    // console.log({ svgs });
    const viewBox = getViewBox(svgs);
    const viewBoxWidth = viewBox?.[2] || 0;
    const viewBoxHeight = viewBox?.[3] || 0;
    // console.log(viewBox);
    // if (!shapesCache[svgUrl]?.shapes) { //! If we use caching here, it breaks 2D render order changes, specifically there is a 'lag' when you move the render order of SVG buttons
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shapeArray = svgs.map((obj) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return obj.paths.reduce((acc, path, index) => {
            return acc.concat(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            path.toShapes(true).map((shape) => ({
                shape,
                color: path.color,
                fillOpacity: path.userData.style.fillOpacity,
                index,
            })));
        }, []);
    })[0];
    shapesCache[svgUrl] = {
        pos: position, // calcPosition(shapeArray, position) as ITuple3,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        shapes: shapeArray.map((shapeData, i) => {
            return (_jsx(SvgShape, { raycast: raycast, name: name, opacity: opacity || shapeData.fillOpacity, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                color: (c || shapeData.color), depthWrite: true, shape: shapeData.shape, renderOrder: renderOrder }, i));
        }),
    };
    // }  // End cache loop
    if (!shapesCache[svgUrl]?.shapes?.length)
        return null;
    // console.log({scale});
    // console.log({position});
    // console.log(shapesCache[svgUrl]);
    const s = [
        scale[0] / viewBoxWidth,
        -scale[1] / viewBoxHeight,
        scale[2],
    ];
    const p = [
        position[0] - scale[0] / 2,
        position[1] + scale[1] / 2,
        position[2] + s[2] / 2,
    ];
    // 	console.log({ s });
    //   console.log({ p });
    return (_jsx("group", { scale: s, position: p, 
        // renderOrder={renderOrder} 
        name: "SVG-Outer Group", visible: visible, children: _jsx("group", { name: "SVG-Inner Group", children: shapesCache[svgUrl].shapes }) }));
};
export default memo(SvgComponent);
